var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-keyboard-container",class:{ capslock: _vm.capslock }},[_c('div',{ref:"keyboard",staticClass:"simple-keyboard"})])
}
var staticRenderFns = []

export { render, staticRenderFns }